import { useMemo } from 'react';
import { SystemEventTypeEnum, TPlayerActionData, TPlayerActionHandlers, TPlayerActionOption, TWAction } from '@libs/types';
import { eventBus, setLocale } from '@libs/utils';
import { ConsumerActionPlayerNameEnums } from '../types/enums';
import { redirectTo } from '../utils/redirect';
import { sanitizeHttpUrl } from '../utils/sanitize';

declare const APP_TITLE: string;

export const usePlayerActionHandlers = (): TPlayerActionHandlers => {
    return useMemo<TPlayerActionHandlers>(() => {
        const handler = (action: TWAction, _options?: TPlayerActionOption, value?: TPlayerActionData, finalValue?: TPlayerActionData) => {
            switch (action.name) {
                case ConsumerActionPlayerNameEnums.share: {
                    const text = value as string;
                    if (navigator.share) {
                        navigator.share({ title: APP_TITLE, text }).catch(() => window.open(text, '_blank'));
                    } else {
                        window.open(text, '_blank');
                    }
                    break;
                }
                case ConsumerActionPlayerNameEnums.execute:
                    if (action.widgetId) {
                        eventBus.emit(SystemEventTypeEnum.EXECUTE, action.widgetId, value as string);
                    }
                    break;
                case ConsumerActionPlayerNameEnums.changeLanguage:
                    setLocale(finalValue as string);
                    break;
                case ConsumerActionPlayerNameEnums.redirect: {
                    const url = sanitizeHttpUrl(value as string);
                    if (url) {
                        redirectTo(url);
                    }
                    break;
                }
            }
        };

        const names = [
            ConsumerActionPlayerNameEnums.share,
            ConsumerActionPlayerNameEnums.execute,
            ConsumerActionPlayerNameEnums.changeLanguage,
            ConsumerActionPlayerNameEnums.redirect,
        ];
        return Object.fromEntries(names.map((name) => [name, handler])) as TPlayerActionHandlers;
    }, []);
};
